function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1e53bdf8\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../vue-loader/lib/selector?type=styles&index=0!./tag.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./tag.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1e53bdf8\",\"hasScoped\":true}!../../../../vue-loader/lib/selector?type=template&index=0!./tag.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e53bdf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/iexplore/components/tags/src/tag.vue
// module id = 1085
// module chunks = 2